import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpUserEvent } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SpinnerService } from '../services/spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from '../services/toastr.service';

import * as _ from 'lodash';
import * as http_errors from '../../assets/i18n/http_errors';
import { Router } from '@angular/router';

/*
 * Interceptor that handles calls to the back and answers
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
   loadingCount: any = 0;
   screensWithoutLoading = ["pages/dashboard", "/pages/works/#/detail", "/pages/works/#/tracking" , "/pages/recommendations/dashboard"]
   
   urlsWithoutLoading = [
      `${this.environment.base_URL}/risk-assign`,
   ]
   
   constructor(@Inject("environment") private environment: any,
      private spinnerService: SpinnerService,
      private toastService: ToastrService,
      private translateService: TranslateService,
      private router: Router) { }
      
      intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
         const shouldSkipLoading = this.isScreenIncluede() || this.isUrlExcluded(request.url);
         
         if(!shouldSkipLoading) {
            this.startLoading();
         }
         return new Observable<HttpEvent<any>>(obs => {
            next.handle(request).subscribe(
               (event) => {
                  obs.next(event);
               },
               (err: any) => {
                  const shouldSkipLoading = this.isScreenIncluede() || this.isUrlExcluded(request.url);
                  if(shouldSkipLoading) {
                     this.forceStopLoading();
                  } else {
                     this.stopLoading()
                  }
                  let currentLanguage = this.translateService.currentLang
                  let error = http_errors.errors[currentLanguage]
                  obs.error(err);
               },
               () => {
                  const shouldSkipLoading = this.isScreenIncluede() || this.isUrlExcluded(request.url);
                  if(shouldSkipLoading) {
                     this.forceStopLoading();
                  } else {
                     this.stopLoading()
                  }
                  //console.log('finaliza -> ' + request.url + ' -> contador: ' + this.loadingCount);
                  obs.complete();
               }
            )
      })
   }
 

   startLoading() {
      this.loadingCount += 1;
      this.spinnerService.loading(true);
   }

   stopLoading() {
      this.loadingCount -= 1;
      if (this.loadingCount <= 0) {
         this.spinnerService.loading(false);
      }
   }

   forceStopLoading() {
      this.loadingCount = 0;
      this.spinnerService.loading(false);
   }

   isScreenIncluede() {
      return this.screensWithoutLoading.some(screen => {
         let screenPaths = screen.split('#')
         return screenPaths.every(s => this.router.url.includes(s))

      })
   }

   isUrlExcluded(url: string): boolean {
      return this.urlsWithoutLoading.some(excludedUrl => url.includes(excludedUrl));
   }

}
